<template>
  <div class="page-container">
    <!-- 内容层（浮在背景之上） -->
    <div class="content-layer">
      <!-- Banner 装饰元素 -->
      <div class="banner" >

      </div>
      <!-- 加载中 -->
      <div v-if="loading" class="loading">查询中...</div>
      <!-- 验证成功 -->
      <div v-else-if="isExist" class="success">
         <div class="titleicon">
           <img src="../../assets/images/success.png" />
         </div>
         <div class="title">验证成功</div>
         <div class="content">感谢您选择本品牌正品产品,请安心使用。</div>
         <div class="tip">本次真伪核验过程数据将受加密保护，我们严格遵守个人信息保护相关法规，不会收集、泄露您的个人隐私信息。</div>
         <div class="regit">注册会员领积分</div>
         <div class="continue" @click="goProductDetail">继续</div>
      </div>
      <!-- 验证失败 -->
      <div v-else class="fail">
         <div class="titleicon">
           <img src="../../assets/images/fail.png" />
         </div>
         <div class="title">验证失败</div>
         <div class="content">未查询到此产品信息</div>
      </div>
    </div>
  </div>
</template>

<script>
import { parseQuery } from "@utils/index";
import { getTraceabilityCodeInfo } from "@api/code";

export default {
  name: "Verification",
  data() {
    return {
      loading: true,
      isExist: false,
      productId: null,
      code: "",
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const query = parseQuery();
      const queryCode = query.code;
      if (!queryCode) {
        this.loading = false;
        this.isExist = false;
        return;
      }
      this.fetchCodeInfo(queryCode);
    },
    fetchCodeInfo(queryCode) {
      this.loading = true;
      getTraceabilityCodeInfo(queryCode)
        .then((res) => {
          // 接口返回 code === 200 时走到这里，说明溯源码存在
          const data = (res && res.data) || {};
          this.productId = data.productId || null;
          this.code = data.code || queryCode;
          this.loading = false;
          this.isExist = true;
        })
        .catch(() => {
          // 接口返回 code === 7003 等非 200 时走到这里，说明溯源码不存在
          this.loading = false;
          this.isExist = false;
        });
    },
    goProductDetail() {
      if (this.productId) {
        this.$router.push({
          name: "ProductTraceability",
          params: { id: this.productId },
          query: { code: this.code },
        });
      }
    },
  },
};
</script>

<style scoped>
/* ===== 容器：占满视口 ===== */
.page-container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden; /* 防止横向溢出出现白边 */
}


/* ===== 内容层：相对定位，在背景之上 ===== */
.content-layer {
  position: relative;
  width: 100%;
  min-height: 100vh;
  z-index: 1;
  /* 关键：让内容层和背景图保持相同的宽高比 */
  aspect-ratio: 490 / 942; /* 设计稿宽高比 */
  margin: 0 auto;
}

/* ===== Banner：水平居中 ===== */
.banner {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  /* 顶部位置按屏幕宽度等比缩放：302 / 490 * 100vw */
  top: calc(180 / 490 * 100vw);
  /* 宽高都用 vw 单位，兼容性更好 */
  width: calc(300 / 490 * 100vw);
  height: calc(91 / 490 * 100vw);
  background: url('../../assets/images/banner.png') no-repeat center center;
  background-size: 100% 100%;
}

/* ===== 加载中 ===== */
.loading {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
  color: #666;
}

/* ===== 验证成功：水平居中 ===== */
.success {
    position: absolute;
    left: 50%;
    top: calc(350 / 942 * 100%);
    transform: translateX(-50%);
    width: calc(386 / 490 * 100%);
    height: 249px;
    opacity: 1;
    border-radius: 26px;
    background: rgba(240, 240, 240, 1);
    font-family: "阿里巴巴普惠体", "Alibaba PuHuiTi", -apple-system, BlinkMacSystemFont, sans-serif;
}
.success .titleicon {
  position: absolute;
  left: 50%;
  top: calc(12 / 249 * 100%); /* 离弹出层顶部 12px（相对 success 高度 249px） */
  transform: translateX(-50%);
  width: calc(29 / 386 * 100%); /* 相对 success 宽度（386px）计算 */
  aspect-ratio: 1 / 1;
}
.success .titleicon img {
  width: 100%;
  height: 100%;
  display: block;
}
/* ===== 继续按钮：水平居中 ===== */
.success .continue {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: calc(186 / 249 * 100%); /* 705 - 519 = 186px（相对 success 高度 249px） */
  width: calc(168 / 386 * 100%);
  height: calc(51 / 249 * 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(181, 151, 116, 1);
  font-size: 16.5px;
  font-weight: 500;
  line-height: 22.64px;
  color: rgba(255, 255, 255, 1);
}
/* ===== 注册会员：水平居中，不换行，下划线 ===== */
.success .regit {
  position: absolute;
  left: 50%;
  top: calc(160 / 249 * 100%);
  transform: translateX(-50%);
  white-space: nowrap;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 16.41px;
  color: rgba(0, 0, 0, 1);
  text-align: center;
  vertical-align: middle;
  display: inline-block;
  border-bottom: 1px solid rgba(0, 0, 0, 1);
  padding-bottom: 2px;
}
/* ===== 提示文本：最多2行，字号随屏幕缩放 ===== */
.success .tip {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: calc(122 / 249 * 100%);
  width: calc(300 / 386 * 100%);
  text-align: left;
  /* 字号按屏幕宽度等比缩放：11.5 / 490 * 100vw */
  font-size: calc(11.5 / 490 * 100vw);
  font-weight: 400;
  line-height: 1.4;
  color: rgba(175, 174, 174, 1);
  /* 最多显示2行，超出省略 */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
/* ===== 内容文本：不换行，字号随屏幕缩放 ===== */
.success .content {
  position: absolute;
  left: 50%;
  top: calc(93 / 249 * 100%);
  transform: translateX(-50%);
  width: calc(322 / 386 * 100%);
  white-space: nowrap;
  text-align: center;
  /* 字号按屏幕宽度等比缩放：16.5 / 490 * 100vw */
  font-size: calc(16.5 / 490 * 100vw);
  font-weight: 400;
  line-height: 22.64px;
  color: rgba(0, 0, 0, 1);
}
/* ===== 标题文本：水平居中 ===== */
.success .title {
  position: absolute;
  left: 50%;
  top: calc(50 / 249 * 100%); /* titleicon 底部间距（相对 success 高度 249px） */
  transform: translateX(-50%);
  white-space: nowrap;
  font-size: 27px;
  font-weight: 400;
  line-height: 37.04px;
  color: rgba(0, 0, 0, 1);
}

.fail {
    position: absolute;
    left: 50%;
    top: calc(350 / 942 * 100%);
    transform: translateX(-50%);
    width: calc(386 / 490 * 100%);
    height: 202px;
    opacity: 1;
    border-radius: 26px;
    background: rgba(240, 240, 240, 1);
    font-family: "阿里巴巴普惠体", "Alibaba PuHuiTi", -apple-system, BlinkMacSystemFont, sans-serif;
}
.fail .title {
  position: absolute;
  left: 50%;
  top: calc(86 / 202 * 100%); /* titleicon 底部间距（相对 fail 高度 202px） */
  transform: translateX(-50%);
  white-space: nowrap;
  font-size: 31px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 42.53px;
  color: rgba(0, 0, 0, 1);
  text-align: center;
  vertical-align: middle;
}

.fail .titleicon {
  position: absolute;
  left: 50%;
  top: 35px; /* 离弹出层顶部 14px（相对 fail 高度 202px） */
  transform: translateX(-50%);
  width: 41px;
  height: 41px;
}
.fail .titleicon img {
  width: 41px;
  height: 41px;
  display: block;
}
.fail .content {
  position: absolute;
  left: 50%;
  top: 139px;
  transform: translateX(-50%);
  width: calc(322 / 386 * 100%);
  white-space: nowrap;
  text-align: center;
  /* 字号按屏幕宽度等比缩放：16.5 / 490 * 100vw */
  font-size: calc(20 / 490 * 100vw);
  font-weight: 400;
  line-height: 22.64px;
  color: rgba(87, 87, 87, 1);
}
</style>
